(function($) {


	var wow = new WOW(
      {
  		mobile: false
    }
    )
    wow.init();

	//universal vars
	var 	siteHeader = $('header.site-header'),
			backgroundwrapper = $('.background-wrapper'),
			scrollDistance = $(window).scrollTop();

	$(document).ready(function(){

		// store filter for each group
var buttonFilters = {};
var buttonFilter;
// quick search regex
var qsRegex;

// init Isotope
var $grid = $('.grid').isotope({
  itemSelector: '.element-item',
  filter: function() {
    var $this = $(this);
    var searchResult = qsRegex ? $this.text().match( qsRegex ) : true;
    var buttonResult = buttonFilter ? $this.is( buttonFilter ) : true;
    return searchResult && buttonResult;
  },
});

$('.filters').on( 'click', '.button', function() {
  var $this = $(this);
  // get group key
  var $buttonGroup = $this.parents('.button-group');
  var filterGroup = $buttonGroup.attr('data-filter-group');
  // set filter for group
  buttonFilters[ filterGroup ] = $this.attr('data-filter');
  // combine filters
  buttonFilter = concatValues( buttonFilters );
  if($this != $('button#all-cat-button')) {
  	$('#clearFilters').slideDown('slow');
  }
  else if ($this == $('button#all-cat-button') && $('.quicksearch').val()=='') {
  	$('#clearFilters').slideUp('slow');
  }
  // Isotope arrange
  $grid.isotope();
});

// use value of search field to filter
var $quicksearch = $('.quicksearch').keyup( debounce( function() {
$([document.documentElement, document.body]).animate({
        scrollTop: $("#directory-outer").offset().top - 100
    }, 1000);
  qsRegex = new RegExp( $quicksearch.val(), 'gi' );
  $grid.isotope();

  if($('.quicksearch').val()=='') {
  	$('#clearFilters').slideUp('slow');
  }
  else {
  	$('#clearFilters').slideDown('slow');
  }
}) );

// change is-checked class on buttons
$('.button-group').each( function( i, buttonGroup ) {
  var $buttonGroup = $( buttonGroup );
  $buttonGroup.on( 'click', 'button', function() {
    $buttonGroup.find('.is-checked').removeClass('is-checked');
    $( this ).addClass('is-checked');

    if($(window).width() < 768) {
		$('.filter-group-wrapper').fadeToggle();
    	$('#show-filters').html('<span class="button-inner"><i class="fa-solid fa-filter"></i> Show Filters</span>').toggleClass('filters-active');
    }
  });
});
  
// flatten object by concatting values
function concatValues( obj ) {
  var value = '';
  for ( var prop in obj ) {
    value += obj[ prop ];
  }
  return value;
}

// debounce so filtering doesn't happen every millisecond
function debounce( fn, threshold ) {
  var timeout;
  threshold = threshold || 100;
  return function debounced() {
    clearTimeout( timeout );
    var args = arguments;
    var _this = this;
    function delayed() {
      fn.apply( _this, args );
    }
    timeout = setTimeout( delayed, threshold );
  };
}

$('#clearFilters').on('click',function(event){
	$('button#all-cat-button').click();
	$('.quicksearch').val('');
	$('#clearFilters').slideUp('slow');

	qsRegex = new RegExp( '', 'gi' );
  	$grid.isotope();
});


		$('.testimonials-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  arrows: true,
		  appendArrows: $('#test-slider-buttons'),
		  appendDots: $('#test-slider-dots'),
		});

		$('.homepage-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 1,
		  arrows: true,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: true,
		});

		$('.posts-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 3,
		  arrows: true,
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: false,
		  appendArrows: $('#posts-slider-buttons'),
		  appendDots: $('#posts-slider-dots'),
		    responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		       slidesToShow: 2,
		      }
		    },
		    {
		      breakpoint: 600,
		      settings: {
		       centerMode: true,
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        centerMode: true,
		      }
		    }
		    ],
		});

		$('#ads-slider').slick({
		  dots: true,
		  infinite: true,
		  speed: 1000,
		  slidesToShow: 3,
		  arrows: true,
		  centerMode: true,
		  // centerPadding: '100px',
		  adaptiveHeight: false,
		  autoplay: true,
		  fade: false,
		  appendArrows: $('#ads-slider-buttons'),
		  appendDots: $('#ads-slider-dots'),
		    responsive: [
		    {
		      breakpoint: 1024,
		      settings: {
		       slidesToShow: 2,
		      }
		    },
		    {
		      breakpoint: 767,
		      settings: {
		       slidesToShow: 1,
		      }
		    },
		    {
		      breakpoint: 480,
		      settings: {
		        slidesToShow: 1,
		        centerMode: false,
		      }
		    }
		    ],
		});

		
		$('.corporate-slider').slick({
			dots: true,
			arrows: true,
			infinite: true,
			speed: 400,
			slidesToShow: 3,
			centerMode: false,
			autoplay: true,
			appendDots: $('#corp-slider-dots'),
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 2
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			     centerMode: false,
			  }
			}
			]
		});

		// 	$('.corporate-pat-slider').slick({
		// 	dots: true,
		// 	arrows: true,
		// 	infinite: true,
		// 	speed: 400,
		// 	slidesToShow: 3,
		// 	centerMode: false,
		// 	autoplay: true,
		// 	appendDots: $('#corp-patron-slider-dots'),
		// 	responsive: [
		// 	{
		// 	  breakpoint: 768,
		// 	  settings: {
		// 	    slidesToShow: 2
		// 	  }
		// 	},
		// 	{
		// 	  breakpoint: 480,
		// 	  settings: {
		// 	    slidesToShow: 1,
		// 	     centerMode: false,
		// 	  }
		// 	}
		// 	]
		// });

	//This option is for pages with a slider of images
	var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { captionPosition: 'outside'});
		//if($(window).width() > 700) {
		$('.image-gallery').slick({
		  arrows: true,
		  infinite: true,
		  speed: 300,
		  slidesToShow: 1,
		  centerMode: true,
		  variableWidth: true,
		  autoplay:true,
		  initialSlide: 1,
		  responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 2
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			     centerMode: false,
			     variableWidth: false,
			  }
			}
			]
	});
	//}


		//This will create a lightbox gallery to replace the default wordpress gallery
		 var galleryItems = $('.wp-block-gallery .wp-block-image');

		  galleryItems.each(function() {
		  
		  var   caption = $(this).find( "figcaption" ),
		        captionText = $(caption).text(),
		        link = $(this).find( "a" ),
		        image = $(this).find( "img" );
		  $(image).attr('title', captionText);


		  });
		   // Galleries on Project Pages

		   if($('.wp-block-gallery').length > 0) {
		      var lightbox = new SimpleLightbox('.wp-block-gallery .wp-block-image a', {
		        // captionSelector : 'figcaption',
		        // captionType : 'text'
		      });
		    }
	});


var corporateSliderInit = function($sliderClass,$dotsID){
		var slider = $($sliderClass);

		slider.slick({
			dots: true,
			arrows: true,
			infinite: true,
			speed: 400,
			slidesToShow: 3,
			centerMode: false,
			autoplay: true,
			appendDots: $($dotsID),
			responsive: [
			{
			  breakpoint: 768,
			  settings: {
			    slidesToShow: 2
			  }
			},
			{
			  breakpoint: 480,
			  settings: {
			    slidesToShow: 1,
			     centerMode: false,
			  }
			}
			]
		});
		slider.fadeIn(300);

		setTimeout(
		  function() 
		  {
		   var logoExcerpt = slider.find('.logo-excerpt');
			sizeBoxes(logoExcerpt);
			//console.log(event);
		  }, 100);
	};

$('.corp-button').on('click',function(){
	var sliderTarget = $(this).data('slide-target'),
		dotsTarget = $(this).data('dots-target');
	$('.corp-button').removeClass('active-slide');
	$(this).addClass('active-slide');

	$('.corp-slider').each(function(i){
		$(this).hide();
		if($(this).hasClass('slick-initialized')) {
			$(this).slick('unslick');
		}
	});
	
	corporateSliderInit(sliderTarget,dotsTarget);

	// $(sliderTarget).on('init', function(event, slick, direction){
		
	
	// });

});

	$(window).on('load',function() {

		//sizeBoxes('.post-wrapper h2');
		sizeBoxes('.entry-excerpt');
		sizeBoxes('.tm-title-wrapper-inner');
		// sizeBoxes('.corporate-pat-slider .logo-excerpt');
		sizeBoxes('.corporate-slider  .logo-excerpt');
		

		// Animate loader off screen
	    $("#loader").fadeOut(300);

	    $('.slick-dots').each(
	    	function(i){
	    		var count = $(this).children().length;
	    		if(count < 2) {
	    			$(this).hide();
	    		}
	    	}
	    	);
	});

	
	//scroll functions
	var 	mainNavbar = $('#main-nav-bar'),
			mainNavbarOffset = mainNavbar.offset().top;

	$(window).on('scroll',function() {
		//
		//stickyHeaderClass(scrollDistance,400,siteHeader);

		var scrollDistance = $(window).scrollTop();

			if($('body').hasClass('admin-bar')) {
				scrollDistance = $(window).scrollTop() + $('div#wpadminbar').innerHeight();
			}


				if(mainNavbarOffset <= scrollDistance) {
					mainNavbar.css('position','fixed');
				}

				else if (mainNavbarOffset > scrollDistance)  {
					mainNavbar.css('position','static');
				}


	});

	//sticky header function
	// var stickyHeaderClass = function(scrollDistanceMonitor, classDistance, headerSelector){
	// 	if(scrollDistanceMonitor > classDistance) {
	// 		$(headerSelector).addClass('scrolled');
	// 		//$('.top-title').fadeOut(300, function(){
	// 			//$('.scroll-title').fadeIn(300, function() {
	// 				$('.site-title').addClass('scaled-title');
	// 				$('ul#extra-nav').removeClass('small-margin-bottom').addClass('no-margin-bottom');

	// 			//});
	// 		//});	
	// 	}
	// 	else {
	// 		$(headerSelector).removeClass('scrolled');
	// 		//$('.scroll-title').fadeOut(0, function(){
	// 			//$('.top-title').fadeIn(300, function() {
	// 				$('.site-title').removeClass('scaled-title');
	// 				$('ul#extra-nav').addClass('small-margin-bottom').removeClass('no-margin-bottom');
	// 			//});
	// 		//});
	// 	}
	// };

	var sizeBoxes = function(boxSelector){
		var boxSize = 0;

		$(boxSelector).each(function(index){
			var heightSet = $(this).innerHeight();
			if(heightSet > boxSize) {
				boxSize = heightSet;
			}
		});
		// if($(window).width() > 767) {
			$(boxSelector).css('height', boxSize + 'px');
		// }
		console.log(boxSize);
	};


//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});


$(document).on('click' , function(e){
    var $menu = $('.nav-primary'),
        $targetBody = $('body'),
        $menuButton = $('.menu-toggle'),
        $searchOverlayForm = $('.search-overlay-form'),
        $searchOverlay = $(".search-overlay"),
        $menuSearchButton = $('.menu-search a');

    // When the search menu is open this will close it on click outside form
    if (!$searchOverlayForm.is(e.target) // if the target of the click isn't the container...
    && $searchOverlayForm.has(e.target).length === 0 && !$menuSearchButton.is(e.target) && $targetBody.hasClass('search-open')) 
    // ... nor a descendant of the container

    {       event.preventDefault();
            $($targetBody).removeClass('search-open');
            event.stopPropagation();
    }
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 


//animate all anchor links

document.querySelectorAll('a[href^="#"]:not(.input)').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});

//this function os to animate numbers on the screen
if($('#counter-container').length > 0) {
	$(window).scroll(startCounter);

	function startCounter() {
	  let scrollY = (window.pageYOffset || document.documentElement.scrollTop) + window.innerHeight - 150;
	  let divPos = document.querySelector('#counter-container').offsetTop;

	  if (scrollY > divPos) {
	    $(window).off("scroll", startCounter);

	    $('.count').each(function() {
	      var $this = $(this);
	      jQuery({
	        Counter: 0
	      }).animate({
	        Counter: $this.text().replace(/,/g, '')
	      }, {
	        duration: 2000,
	        easing: 'swing',
	        step: function() {
	          $this.text(commaSeparateNumber(Math.floor(this.Counter)));
	        },
	        complete: function() {
	          $this.text(commaSeparateNumber(this.Counter));
	          //alert('finished');
	        }
	      });
	    });

	    function commaSeparateNumber(num) {
	      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	    }
	  }
	}
}

//this function is connected to the publications download
$('.toggle-download-form').on('click',function(event){
	var formTarget = $(this).siblings('.download-form-wrapper');

	event.preventDefault();
	return false;
	$('.download-form-wrapper').fadeOut(300);
	formTarget.fadeToggle(300);
	$('body').toggleClass('download-form-is-open');
});

$('.team-nav-section a').on('click',function(event){
	event.preventDefault();
		if($(this).hasClass('active')) {
			return false;
		}
		else {
			$('.team-nav-section a').removeClass('active');
			$(this).addClass('active');
			$('.team-member-section').removeClass('current-tm-section');

		var teamSection = $(this).data('team-section');

		$('.team-member-section').fadeOut('slow',function(){
			$(teamSection).fadeIn(300, function(){
				$(teamSection).addClass('current-tm-section');
			})
		});
	}
});

$('button.account-button').on('click',function(event){

	$('#account-info').toggle().toggleClass('acc-info-open');

});

var $accountInfo = $('#account-info'); 

$(document).on('click' , function(e){
   var $accountButton = $('button.account-button');
    if($accountInfo.hasClass('acc-info-open')) {
    // When the search menu is open this will close it on click outside form
	    if (!document.getElementById('account-info').contains(e.target) && !$accountButton.is(e.target))
	    // ... nor a descendant of the container

	    {       event.preventDefault();
	            $('#account-info').hide().toggleClass('acc-info-open');
	            event.stopPropagation();
	    }
	}
});

// $('#directory-panel-link').on('click',function(event){
	
// });

$('#example-tabs').on('change.zf.tabs', function() {
  $('#all-cat-button').click();
});

$('#show-filters').on('click',function(event){
	$('.filter-group-wrapper').fadeToggle();
	if(!$(this).hasClass('filters-active')) {
	$(this).html('<span class="button-inner"><i class="fa-solid fa-xmark"></i> Hide Filters</span>').toggleClass('filters-active');
	}
	else{
	$(this).html('<span class="button-inner"><i class="fa-solid fa-filter"></i> Show Filters</span>').toggleClass('filters-active');
	}

	$([document.documentElement, document.body]).animate({
        scrollTop: $("#directory-outer").offset().top - 100
    }, 1000);
});

$('#edit-company').on('click',function(event){
	$('#edit-company-form').fadeToggle(300);
});

$('.add-new-mem').on('click',function(event){
	var formToShow = $(this).siblings('.add-new-form');

	formToShow.fadeToggle(300);
});

// $(document).ready(function(){
// 	var hashParams = window.location.hash.substr(1).split('&'); // substr(1) to remove the `#`
// 	for(var i = 0; i < hashParams.length; i++){
// 	    var p = hashParams[i].split('=');
// 	    document.getElementById(p[0]).value = decodeURIComponent(p[1]);;
// 	}
// });

$('#presidents-select').on('change',function(){
	var selection = $(this).val();

	$('.presidents-archive').each(function(i){
		if(selection == $(this).attr('id')){
			$(this).fadeIn();
		}
		else if(selection == 'presidents-all'){
			$('.presidents-archive').fadeIn();
		}
		else{
			$(this).hide();
		}
	});
});

$('#show-account-details').on('click',function(event){
	$('form#mepr_account_form').fadeToggle(300);
	$('span.mepr-account-change-password').fadeToggle(300);
	
});

$('button.multi-button').on('click',function(){
	var $policy = $(this).data('policy');

	$('.section-row-multi').hide();

	$($policy).fadeIn(300);

	$('button.multi-button').removeClass('active');

	$(this).addClass('active');
});
	
})( jQuery );